import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  Dialog,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';
import { Stepper } from '@mint-lib/tw-components/patterns';

import type { Activity } from '../../../../types/activity.types.js';
import { CreateActivity } from './CreateActivity.jsx';
import { CreateFlight } from './CreateFlight.jsx';

type CreateActivityModalProps = {
  onClose: () => void;
};

export const CreateActivityAndFlightModal = ({
  onClose,
}: CreateActivityModalProps) => {
  const { t } = useTranslation('@myn/planning_v2');
  const [activity, setActivity] = useState<Activity | null>(null);

  const steps = [{ title: t('Main info') }, { title: t('Flights') }];

  const stepper = (
    <Stepper
      steps={steps}
      activeStep={activity ? 1 : 0}
      completedStep={{
        0: Boolean(activity),
      }}
    />
  );

  return (
    <Dialog modal open>
      <DialogOverlay
        onClick={onClose}
        data-dd-action-name="Create activity and flights modal: close"
      />
      <DialogRoot size="m">
        <DialogHeader
          onClose={onClose}
          data-dd-action-name="Create activity and flights modal: close"
        >
          <DialogTitle>{t('New activity')}</DialogTitle>
        </DialogHeader>
        {!activity && (
          <CreateActivity
            stepper={stepper}
            onClose={onClose}
            onCreated={setActivity}
          />
        )}
        {activity && (
          <CreateFlight
            activity={activity}
            stepper={stepper}
            onConfirm={onClose}
          />
        )}
      </DialogRoot>
    </Dialog>
  );
};
